import { FC, useEffect, useState } from "react";
import TranscodePresetsPopupFooterProps from "./TranscodePresetsPopupFooter.interface";
import { Button } from "../../Button";
import Icon from "../../Icon";
import { ViewModes } from "../TranscodePresetsPopup.interface";
import { Pagination } from "../../Pagination";
import { useGetTranscodePresetsQuery } from "../../../features/api/apiSlice";
import { useScreenWidth } from "../../../hooks/useScreenWidth";
import { CREATE_FORM_ID, UPDATE_FORM_ID } from "../TranscodePresetsPopup.data";

import styles from "./TranscodePresetsPopupFooter.module.css";

const TranscodePresetsPopupFooter: FC<TranscodePresetsPopupFooterProps> = ({
  viewMode,
  paginationParams,
  isShowleftButtons,
  transcodePresetToUpdate,
  currentPage,
  isLoading,
  onChangeViewMode,
  onReset,
  onSelect,
  onClose,
  setCurrentPage,
}) => {
  const { isMobile } = useScreenWidth();
  const { data: transcodePresets } = useGetTranscodePresetsQuery({ ...paginationParams });
  const [displayPages, setDisplayPages] = useState(0);

  const renderCreateUpdateModeFooter = ({
    formId,
    actionButtonLabel
  }: {
    formId: string;
    actionButtonLabel: string;
  }) => (
    <div className={styles["transcode-presets-popup__footer-buttons-container"]}>
      <div></div>

      <Button
        kind="primary"
        type="submit"
        form={formId}
        className={styles["transcode-presets-popup__footer-submit-button"]}
      >
        {actionButtonLabel}
      </Button>

      <div className={styles["transcode-presets-popup__footer-right-button-container"]}>
        <Button
          kind="secondary"
          onClick={() => onChangeViewMode(ViewModes.PRESETS_LIST)}
          className={styles["transcode-presets-popup__footer-small-button"]}
        >
          {isMobile ? <Icon name="arrow-back-small" /> : "Назад"}
        </Button>
      </div>
    </div>
  );

  useEffect(() => {
    if (!transcodePresets) return;

    const maxItemCount = paginationParams.per_page;
    const newDisplayPages = Math.ceil(transcodePresets?.total / maxItemCount);

    setDisplayPages(newDisplayPages);
  }, [transcodePresets]);

  return (
    <>
      {viewMode === ViewModes.PRESETS_LIST && (
        <div className={styles["transcode-presets-popup__footer-buttons-container"]}>
          <div className={styles["transcode-presets-popup__footer-left-button-container"]}>
            {isShowleftButtons &&
              <>
                <Button
                  kind="secondary"
                  onClick={onReset}
                  className={styles["transcode-presets-popup__footer-small-button"]}
                >
                  {isMobile ? <Icon name="reset" /> : "Сбросить"}
                </Button>
                <Button
                  kind="primary"
                  onClick={onSelect}
                  className={styles["transcode-presets-popup__footer-small-button"]}
                >
                  {isMobile ? <Icon name="check" /> : "Выбрать"}
                </Button>
              </>
            }
          </div>

          {displayPages > 1 ? (
            <Pagination
              currentPage={currentPage}
              pageCount={displayPages}
              onChangePage={setCurrentPage}
              paginationClassName={styles['transcode-presets-popup__pagination']}
            />
          ) : (
            <div></div>
          )}

          <div className={styles["transcode-presets-popup__footer-right-button-container"]}>
            <Button
              kind="primary"
              onClick={() => onChangeViewMode(ViewModes.CREATE_PRESET)}
              className={styles["transcode-presets-popup__footer-small-button"]}
            >
              {isMobile ? <Icon name="plus" /> : "Создать"}
            </Button>
            <Button
              kind="secondary"
              onClick={onClose}
              className={styles["transcode-presets-popup__footer-small-button"]}
            >
              {isMobile ? <Icon name="arrow-back-small" /> : "Назад"}
            </Button>
          </div>
        </div>
      )}

      {viewMode === ViewModes.CREATE_PRESET && renderCreateUpdateModeFooter({
        formId: CREATE_FORM_ID,
        actionButtonLabel: isLoading ? "Создание..." : "Создать"
      })}

      {viewMode === ViewModes.EDIT_PRESET && transcodePresetToUpdate && renderCreateUpdateModeFooter({
        formId: UPDATE_FORM_ID,
        actionButtonLabel: isLoading ? "Сохранение..." : "Сохранить"
      })}
    </>
  );
};

export default TranscodePresetsPopupFooter;